__turbopack_context__.v({
  "chip": "ConceptFlow-module__k_-BEG__chip",
  "chipClickable": "ConceptFlow-module__k_-BEG__chipClickable",
  "container": "ConceptFlow-module__k_-BEG__container",
  "downWire": "ConceptFlow-module__k_-BEG__downWire",
  "flow": "ConceptFlow-module__k_-BEG__flow",
  "flowIn": "ConceptFlow-module__k_-BEG__flowIn",
  "goal": "ConceptFlow-module__k_-BEG__goal",
  "goalBadge": "ConceptFlow-module__k_-BEG__goalBadge",
  "goalClickable": "ConceptFlow-module__k_-BEG__goalClickable",
  "hub": "ConceptFlow-module__k_-BEG__hub",
  "hubLogo": "ConceptFlow-module__k_-BEG__hubLogo",
  "inputs": "ConceptFlow-module__k_-BEG__inputs",
  "node": "ConceptFlow-module__k_-BEG__node",
  "nodes": "ConceptFlow-module__k_-BEG__nodes",
  "outputs": "ConceptFlow-module__k_-BEG__outputs",
  "side": "ConceptFlow-module__k_-BEG__side",
  "title": "ConceptFlow-module__k_-BEG__title",
  "titleEcho": "ConceptFlow-module__k_-BEG__titleEcho",
  "titleWire": "ConceptFlow-module__k_-BEG__titleWire",
  "wire": "ConceptFlow-module__k_-BEG__wire",
  "wireFlow": "ConceptFlow-module__k_-BEG__wireFlow",
  "wireFlowDown": "ConceptFlow-module__k_-BEG__wireFlowDown",
});
